import store from '@/store';
import router from '../router';
// Utility function to check if the user is a reviewer
export function checkIsReviewerAndRedirect(path) {
  return store.dispatch('loadCurrentUser')
    .then(() => {
      const isReviewer = store.getters.isCreateReviewUser;
      if (!isReviewer) {
        router.push({ path });
      }
    })
    .catch(error => {
      console.error('Failed to load current user:', error);
    });
}